import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/roomHeat.png'


const _withScopeId = n => (_pushScopeId("data-v-b55563d2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "news" }
const _hoisted_2 = {
  key: 0,
  class: "anchor"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "anchor-centen-box" }
const _hoisted_5 = { class: "anchor-centen-box-top" }
const _hoisted_6 = ["src"]
const _hoisted_7 = {
  key: 0,
  class: "anchor-centen-box-bottom"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1 /* HOISTED */))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1 /* HOISTED */))
const _hoisted_10 = { class: "anchor-centen-bottem" }
const _hoisted_11 = { class: "ovehide" }
const _hoisted_12 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_image = _resolveComponent("van-image")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      title: $setup.t('me.lsjl'),
      "left-arrow": "",
      fixed: "",
      "z-index": "99",
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => ($setup.ToBack($setup.router)))
    }, null, 8 /* PROPS */, ["title"]),
    ($setup.data.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.slice(0, 3), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "anchor-centen",
              key: index,
              onClick: ($event: any) => ($setup.toLiveRoom(item))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createCommentVNode(" <van-image fit=\"cover\" lazy-load v-if=\"item.screen_shots && item.screen_shots.length > 0\"\r\n            :src=\"item.screen_shots\" alt=\"\" /> "),
                _createVNode(_component_van_image, {
                  fit: "cover",
                  "lazy-load": "",
                  src: item.room_cover,
                  alt: ""
                }, null, 8 /* PROPS */, ["src"]),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("img", {
                    class: "gif",
                    src: $setup.livezb,
                    alt: ""
                  }, null, 8 /* PROPS */, _hoisted_6),
                  _createCommentVNode(" <img v-if=\"item.room_id\" class=\"png\" :src=\"livetj\" alt=\"\"> ")
                ]),
                (item.nickName && item.nickName.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _hoisted_8,
                      _createElementVNode("div", null, [
                        _hoisted_9,
                        _createElementVNode("span", null, _toDisplayString(item.heat), 1 /* TEXT */)
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("p", _hoisted_11, _toDisplayString(item.room_title), 1 /* TEXT */),
                (item.nickName && item.nickName !== '')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(item.nickName), 1 /* TEXT */))
                  : _createCommentVNode("v-if", true)
              ])
            ], 8 /* PROPS */, _hoisted_3))
          }), 128 /* KEYED_FRAGMENT */))
        ]))
      : _createCommentVNode("v-if", true)
  ]))
}